// Outbound app links. The app's login lives on the org/app host.
export const LOGIN_URL = 'https://app.diligenshub.com/context-login';

// The site's one canonical host: the apex (www. 301s here). Every absolute
// site URL is built from it: canonicals, og:url, JSON-LD, robots.txt and the
// sitemap (scripts/). The status page is this same build, served on its own
// host by nginx (README "Status page"). There, every path is the status page,
// so links back to the site's other pages must name the site's host.
export const SITE_URL = 'https://diligenshub.com';
export const STATUS_URL = 'https://status.diligenshub.com';
export const isStatusHost = () => window.location.hostname.startsWith('status.');
export const sitePath = (path) => (isStatusHost() ? `${SITE_URL}${path}` : path);
